import { Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss'],
})
export class PageTitleComponent implements OnInit {
  @Input() routeTo = '';
  @Input() title = '';

  constructor(private router: Router, private location: Location) {}

  ngOnInit() {}

  goBack(defaultPath: string = '/dashboard') {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      this.router.navigate([defaultPath]);
    }
  }
}
